<template>
    <div class="card bs-5 mb-5">
        <div class="fl-te-c pb-3">
            <h4 v-html="'VIDEOS'"></h4>
            <div>
                <btn color="success" icon="fa fa-plus" size="md" @click="$refs.videoAddModal.show()" text="Add"/>
            </div>
        </div>
        <vue-table :fields="fields" :url="listUrl" :per-page="10" ref="table">
            <template #disabled="{rowData}">
                <checkbox-input v-model="rowData.disabled" @input="disable(rowData)"></checkbox-input>
            </template>
            <template #actions="{rowData}">
                <div class="btn-group-tight">
                    <delete-btn @click="setDelete(rowData)"/>
                    <edit-btn @click="setEdit(rowData)"/>
                </div>
            </template>
        </vue-table>

        <modal title="Add Video" ref="videoAddModal" width="40r" :no-close-on-backdrop="true" header-color="primary">
            <AddVideo @success="formSuccess"></AddVideo>
        </modal>

        <modal title="Edit Video" ref="videoEditModal" :no-close-on-backdrop="true" width="40r" header-color="primary">
            <EditVideo :initial-data="editingItem" @success="formSuccess"></EditVideo>
        </modal>

        <delete-modal ref="videoDeleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
            <p>You are about to delete the Video <b v-html="deletingItem && deletingItem.title"></b>. Are you sure ?
            </p>

            <template #loading>
                <loading-animation/>
                Please wait while we delete <b v-html="deletingItem && deletingItem.id"></b>.
            </template>
        </delete-modal>

    </div>
</template>

<script>
import urls from '../../../../data/urls';
import axios from 'secure-axios';
import AddVideo from './AddVideo';
import EditVideo from './EditVideo';
import { mapGetters } from 'vuex';

export default {
    name       : 'Video',
    computed   : { ...mapGetters(['currentUser']) },
    components : { AddVideo, EditVideo },
    data () {
        return {
            listUrl      : urls.admin.event.videoGallery.list,
            deleteUrl    : urls.admin.event.videoGallery.delete,
            editingItem  : null,
            deletingItem : null,
            fields       : [
                {
                    name       : 'title',
                    sortField  : 'title',
                    title      : 'Title',
                    titleClass : ''
                },
                {
                    name       : 'video_link',
                    sortField  : 'video_link',
                    title      : 'Video Link',
                    titleClass : ''
                },
                {
                    name       : 'create_date',
                    sortField  : 'create_date',
                    title      : 'Created Date',
                    titleClass : ''
                },
                {
                    name       : '__slot:disabled',
                    sortField  : 'disabled',
                    title      : 'Disabled',
                    titleClass : ''
                },
                {
                    name       : '__slot:actions',
                    title      : 'Actions',
                    titleClass : 'center aligned text-right',
                    dataClass  : 'aligned text-right'
                }
            ]
        };
    },
    methods : {
        formSuccess () {
            const refs = this.$refs;
            refs.videoAddModal.close();
            refs.videoEditModal.close();
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            delete this.editingItem.description;
            this.editingItem.initial_description = item.description;
            this.$refs.videoEditModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.videoDeleteModal.show();
        },

        deleteComplete (response) {
            this.deletingItem = null;
            this.$notify('Successfully Deleted Video..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$refs.videoDeleteModal.close();
            this.$refs.table.refreshTable();
        },

        disable (item) {
            const that = this;
            item.api_key = that.currentUser.api_key;
            axios.form(urls.admin.event.videoGallery.addEdit, item).then(function (response) {
                const json = response.data;
                if (json.error === false) {
                    that.$notify('Successfully Updated Video..!', 'Success',
                        {
                            type : 'success'
                        });
                } else {
                    that.$notify(json.errors, 'Error',
                        {
                            type : 'warning'
                        });
                    item.disabled = !item.disabled;
                }
            }).catch(function (err) {
                item.disabled = !item.disabled;
                console.log('error : ', err);
                that.$notify('Something went wrong..!', 'Success',
                    {
                        type : 'warning'
                    });
            });
        }
    }
};
</script>

<style scoped>

</style>
